import { combineReducers } from 'redux'
import settings from './settings'

const reducer = combineReducers({
    settings
})

export default reducer



// WEBPACK FOOTER //
// ./src/store/reducer.js